

























































































import { Component, Watch } from 'vue-property-decorator';

import BasePagination from '@/components/BasePagination/BasePagination.vue';
import { HeaderList } from '@/components/Table/TableModel';
import { treatValue } from '@/utils/moneyTreatments';
import RowsTable from '@/components/Table/RowsTable.vue';
import TextInput from '@/components/TextInput/TextInput.vue';
import FlexButton from '@/components/FlexButton/FlexButton.vue';
import eventBus from '@/utils/eventBus';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import DateUtils from '@/utils/DateUtils';
import TransactionsService from '@/api/TransactionsService';
import SideModalHeader from '@/components/SideModalHeader/SideModalHeader.vue';
import ContentContainer from '@/components/molecules/ContentContainer/ContentContainer.vue';
import TableCard from '@/componentsV2/molecules/TableCard/TableCard.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';

import Table from '@/components/molecules/Table/Table.vue';
import TableFilters from '@/components/molecules/TableFilters/TableFilters.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import UserIcon from '@/components/molecules/UserIcon/UserIcon.vue';

@Component({
  components: {
    FlexButton,
    RowsTable,
    TextInput,
    SideModalHeader,
    CustomSelect,
    ContentContainer,
    Table,
    TableFilters,
    TableCell,
    TableHeader,
    TableRow,
    UserIcon,
    TableCard,
    Typography
  }
})
export default class Transactions extends BasePagination {
  constructor() {
    super();
  }
  pageName: string = 'Transactions';
  subTitle: string = 'Purchased Coins';
  service: TransactionsService = new TransactionsService();
  labelInputFilter: string = 'Search by customer name';
  searchableFields = 'searchableFields=customer.name';

  get getFlags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  @Watch('isLoading')
  showFullLoadingOnMobile() {
    if (this.isMobileDevice && this.isLoading) {
      this.$showLoaderWithLocker();

      return;
    }

    this.$hideLoader();
  }

  detail(event: any) {
    const modalConfig = {
      isOpen: true,
      component: 'customerDetails',
      data: event.row
    };
    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  get stripeProfile() {
    return this.$store.getters['stripe/getProfile'];
  }

  reloadList(clearList?: boolean, refreshCurrent?: boolean, query?: string) {
    if (clearList) {
      this.resetPagination();
      this.dataList.list = [];
      this.maxItems = false;
    }
    if (this.refreshing || this.maxItems) return;

    this.isLoading = true;
    this.refreshing = true;

    this.service
      .getPurchasedCoins(
        this.sortField,
        this.sortOrder,
        this.pagination,
        this.query
      )
      .then(response => {
        const { data } = response;
        const { items, links } = data;
        if (refreshCurrent) {
          // refresh page and reinitilize pagination
          this.resetPagination();
          this.pagination = links.next;
          if (!links.next) this.maxItems = true;
          this.dataList.list = this.addRowsToList(items);
        } else {
          // refresh page and add items
          this.dataList.list = this.dataList.list.concat(
            this.addRowsToList(items)
          );
          if (!links.next) this.maxItems = true;
          this.pagination = links.next;
        }
      })
      .catch(() => {})
      .finally(() => {
        this.isLoading = false;
        this.refreshing = false;
      });
  }

  // TODO ADD TYPES
  addRowsToList(rows: any): any[] {
    let rowsOrdered: any[] = [];
    rows.forEach((row: any) => {
      rowsOrdered.push({
        name: `${row.customer_name} ${row.customer_lastname}`,
        spent: `${this.businessCurrency}${treatValue(row.totalSpent) || '0'}`,
        reward: treatValue(row.totalRewards) || '0',
        coins: treatValue(row.totalCoins) || '0',
        visits: treatValue(row.totalVisits) || '0',
        id: row.customer_id,
        last_seen: DateUtils.formatISODate(row.lastSeen),

        usdAmount: `${this.businessCurrency}${treatValue(
          row.transaction_money
        )}`,
        coinsAmount:
          treatValue(row.transaction_coins) +
          (row.transaction_bonusCoins !== '0.00'
            ? ` (+${treatValue(row.transaction_bonusCoins)})`
            : ''),
        transactionId: row.transaction_id,
        status: row.statusPurchased || 'Pending',
        date: DateUtils.formatISODate(row.transaction_createdAt)
      });
    });

    return rowsOrdered;
  }

  initHeader() {
    this.dataList.header.push(new HeaderList(`Customer name`, 'customer.name'));
    this.dataList.header.push(
      new HeaderList(
        `${this.businessCurrencyShorthand} amount`,
        'transaction_money'
      )
    );
    this.dataList.header.push(
      new HeaderList(`Coin amount/discount`, 'transaction_coins')
    );
    this.dataList.header.push(new HeaderList(`Date`, 'transaction_createdAt'));
  }

  get businessCurrency() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }

  get businessCurrencyShorthand() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencyShorthand;
  }
}
